"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatisticsText = exports.StatisticsNumbers = exports.StatisticsBox = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container = _styledComponents["default"].div.attrs(function (_ref) {
  var testId = _ref.testId;
  return {
    'data-test-id': testId
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n"])));
exports.Container = Container;
var StatisticsNumbers = _styledComponents["default"].div.attrs(function () {
  return {
    'data-test-id': 'STATISTICS_NUMBERS'
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.numbersFontWeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.numbersFontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.numbersLineHeight;
}, function (_ref5) {
  var theme = _ref5.theme,
    hasError = _ref5.hasError;
  return hasError ? theme.numbersColorError : theme.numbersColor;
});
exports.StatisticsNumbers = StatisticsNumbers;
var StatisticsText = _styledComponents["default"].div.attrs(function () {
  return {
    'data-test-id': 'STATISTICS_TEXT'
  };
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.textFontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.textLineHeight;
}, function (_ref8) {
  var theme = _ref8.theme,
    hasError = _ref8.hasError;
  return hasError ? theme.textColorError : theme.textColor;
});
exports.StatisticsText = StatisticsText;
var StatisticsBox = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  margin: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.boxWidth;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.boxMargin;
});
exports.StatisticsBox = StatisticsBox;